import React, { useState, useEffect, forwardRef } from "react";
import { Table, Button, Modal, Flex, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import API from "@/api";
import IndexStatus from "@/components/zskzx/indexStatus";

const ZdKnowledge = (props, ref) => {
  const { type } = props;
  const [tableData, setTableData] = useState([]);

  const [loadedKeys, setLoadedKeys] = useState([]);

  const [name, setName] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    axios.get(API.getZskList).then((res) => {
      console.log(res);
      setTableData(res?.data?.result?.data);
    });
  }, []);

  // 模拟接口
  const fetchTreeData = (parentId) => {
    return new Promise((resolve) => {
      axios.get(API.getNextZsklist + `?dirid=${parentId}`).then((res) => {
        setTimeout(() => {
          resolve(res?.data?.result?.data || []);
        }, 500);
      });
    });
  };

  // 递归更新数据
  const updateTreeData = (data, targetId, newChildren) => {
    return data.map((node) => {
      if (node.id === targetId) return { ...node, children: newChildren };
      if (node.children)
        return {
          ...node,
          children: updateTreeData(node.children, targetId, newChildren),
        };
      return node;
    });
  };

  // 手动监听展开事件，实现动态加载
  const handleExpand = async (expanded, record) => {
    // 仅展开时加载，且未加载过的节点才请求
    if (expanded && !loadedKeys.includes(record.id)) {
      const childData = await fetchTreeData(record.id);
      const newData = updateTreeData(tableData, record.id, childData);
      setTableData(newData);
      setLoadedKeys([...loadedKeys, record.id]); // 标记为已加载
    }
  };

  if (ref) {
    ref.current = {
      getValue: () => {
        return {
          zskName: name,
          zskId: id,
        };
      },
    };
  }

  return (
    <>
      <Flex justify="space-between" align="center">
        <Typography.Title level={4}>知识库选择</Typography.Title>
        <Button
          icon={<PlusOutlined />}
          onClick={() => {
            window.open("https://kr.zju.edu.cn/anyshare/zh-cn/dir");
          }}
        >
          新建知识库
        </Button>
      </Flex>
      <div
        style={{
          padding: "10px 0",
        }}
      >
        <Table
          bordered
          rowKey="id"
          columns={[
            {
              title: "名称",
              dataIndex: "name",
            },
            {
              title: "所属者",
              dataIndex: "createdBy",
              width:120
            },
            {
              title: "更新时间",
              dataIndex: "modifiedAt",
              width:120
            },
            {
              title: "类型",
              dataIndex: "suffix",
              width:120
            },
            {
              title: "大小",
              dataIndex: "size",
              width:120
            },
            {
              title: "索引状态",
              dataIndex: "a",
              width:120,
              render(val, row) {
                if (row?.type === "file") {
                  return <IndexStatus id={row?.id} />;
                } else {
                  return "";
                }
              },
            },
          ]}
          rowSelection={{
            onChange: (id, row) => {
              console.log(row);
              setName(row?.[0]?.name);
              setId(row?.[0]?.id);
            },
            type: "radio",
            checkStrictly: false,
            getCheckboxProps: (record) => {
              if (type === "zskFile") {
                 if (record?.type !== "file") {
                  return {
                    disabled: true,
                    style: { display: "none" }, // 或者使用 className 隐藏
                  };
                }
              } else {
                if (!record?.createdBy) {
                  return {
                    disabled: true,
                    style: { display: "none" }, // 或者使用 className 隐藏
                  };
                }
              }

              return {};
            },
          }}
          dataSource={tableData}
          // ✅ 核心：用onExpand替代loadData，手动控制加载
          onExpand={handleExpand}
          treeProps={{
            childrenColumnName: "children",
            defaultExpandAll: false,
          }}
          pagination={false}
          style={{ margin: "20px" }}
          scroll={{
            x:960
          }}
        />
      </div>
    </>
  );
};

export default forwardRef(ZdKnowledge);
